<div id="diagram" class="m-3">

    <h3 class="mb-3">Diagrama</h3>

    <div id="diagram-loading" [ngClass]="{ 'd-none' : !diagramLoading }">
        <i class="fas fa-spinner fa-spin"></i>
        <span>Cargando diagrama...</span>
    </div>

    <div id="diagram-container" [ngClass]="{ 'd-none' : diagramLoading }">
        <div id="diagram-buttons" class="mb-3">
            <button class="btn btn-primary me-3" (click)="toggleEdit(!edit)">
                <div *ngIf="edit">
                    <i class="fas fa-eye"></i>
                    <span>Ver</span>
                </div>
                <div *ngIf="!edit">
                    <i class="fas fa-edit"></i>
                    <span>Editar</span>
                </div>
            </button>
            <button class="btn btn-danger me-3" (click)="deleteDiagram()" *ngIf="id > 0">
                <i class="fas fa-times"></i>
                <span>Eliminar</span>
            </button>
        </div>
    
        <div id="diagram-empty" class="mb-3" *ngIf="!edit && id == 0 && code == ''">
            <p>Este enunciado no tiene diagrama.</p>
        </div>
    
        <div id="diagram-show" class="text-center mb-3" [ngClass]="{ 'd-none' : edit || code == '' }">
            <p class="fw-bold">Título: {{ title }}</p>
            <div #diagramShow class="diagram-container mb-3">
                <i class="fas fa-spinner fa-spin"></i>
                <span>Cargando...</span>
            </div>
            <p class="fw-bold" *ngIf="width > 0 && height > 0">Tamaño: {{ width }} x {{ height }}</p>
        </div>

        <div id="diagram-align-container" class="text-center mb-3" [ngClass]="{ 'd-none' : edit || code == '' }">
            <p class="fw-bold">Alineación:</p>
            <select id="diagram-align" [(ngModel)]="align" (ngModelChange)="updateDiagram()">
                <option value="down">Abajo</option>
                <option value="left">Izquierda</option>
                <option value="right">Derecha</option>
            </select>
        </div>
    
        <div id="diagram-edit" class="text-center mb-3" [ngClass]="{ 'd-none' : !edit }">
            <label class="d-block w-50 mx-auto mb-3">
                <span class="fw-bold">Título:</span>
                <input type="text" class="form-control" [(ngModel)]="title">
            </label>
            <label class="d-block mx-auto mb-3 fw-bold">
                <!-- <p><a [href]="liveUrl" target="_blank">Haz clic aquí para editar visualmente</a></p> -->
                <p><a [href]="aiUrl" target="_blank">Haz clic aquí para editar visualmente</a></p>
                <p>Al terminar de editar, copia y pega el código del bloque 'Code' aquí</p>
                <textarea id="diagram-editor" class="form-control mx-auto" [(ngModel)]="code" (ngModelChange)="updateDiagramURL()"></textarea>
            </label>
        </div>

        <div id="diagram-status">
            <div id="diagram-generate-status" class="mb-3">
                <div id="diagram-generate-loading" *ngIf="generateDiagramLoading">
                    <i class="fas fa-spinner fa-spin"></i>
                    <span>Generando diagrama...</span>
                </div>
                <div id="diagram-generate-success" class="text-success" *ngIf="generateDiagramSuccess">
                    <i class="fas fa-check"></i>
                    <span>¡Diagrama generado correctamente!</span>
                </div>
                <div id="diagram-generate-error" class="text-danger" *ngIf="generateDiagramError">
                    <i class="fas fa-times"></i>
                    <span>Error al generar diagrama</span>
                </div>
            </div>

            <div id="diagram-edit-status" class="mb-3">
                <div id="diagram-edit-loading" *ngIf="updateDiagramLoading">
                    <i class="fas fa-spinner fa-spin"></i>
                    <span>Guardando...</span>
                </div>
                <div id="diagram-edit-success" class="text-success" *ngIf="updateDiagramSuccess">
                    <i class="fas fa-check"></i>
                    <span>¡Guardado!</span>
                </div>
                <div id="diagram-edit-error" class="text-danger" *ngIf="updateDiagramError">
                    <i class="fas fa-times"></i>
                    <span>Error al guardar</span>
                </div>
            </div>
        </div>

        <div id="diagram-buttons" class="flex gap-4 mb-3">
            <button class="btn btn-primary me-3" (click)="viewDiagram()" *ngIf="id > 0 || code != ''">
                <i class="fas fa-eye"></i>
                <span>Ver imagen (en nueva pestaña)</span>
            </button>
            <button class="btn btn-success me-3" (click)="updateDiagram($event)" *ngIf="id > 0 || code != ''">
                <i class="fas fa-save"></i>
                <span>Guardar</span>
            </button>
            <button class="btn btn-success me-3" (click)="generateDiagram()">
                <i class="fas fa-chart-diagram"></i>
                <i class="fas fa-wand-magic-sparkles"></i>
                <span>Generar diagrama</span>
            </button>
        </div>
    </div>

</div>